import React, {Component} from 'react';

//Bootstrap
import {Container, Row, Col} from 'reactstrap'

//Css----------**********
import './QuienesSomos.scss'
//-------------**********

//Logo
import logo from '../../Img/Logo Archivo.svg';

class QuienesSomos extends Component{
    render(){
        return(
            <div className={"quienessomos"}>
              <div>
                <Container>
                  <Row>
                    <Col xs="12" sm="6">
                      <embed  src={logo} className="LogoPortaPrent" />
                    </Col>
                    <Col xs="12" sm="6">
                      <div className="divPortaPrent">
                        <h1>PortaPrent</h1>
                        <p>
                        Portaprent una micro empresa que está dedica al diseño y elaboración de productos publicitarios, confiables, versátiles y muy adaptables a cualquier espacio. 
Estos productos vienen fuertemente estructurados para tener una vital útil de aproximadamente 5 años, y resistir hasta 50 kg de pesa.
                        </p>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </div>
              <div className="Inf-PortaPrent">
                <Container>
                  <Row  >
                    <Col xs="0" sm="2"></Col>
                    <Col xs="12" sm="8">
                      <div className="PortaprentM-V">
                        <h5><strong>Misiòn</strong></h5>
                        <p>PortaPrent es una micro empresa basada en el diseño y creación de productos publicitarios tales como Stand ferial, Backing modulares, vitrinas publicitarias, impresión digital de gran formato. contando con una gran experiencia en el área.</p>
                        <h5><strong>Visiòn</strong></h5>
                        <p>En el año 2030 ser reconocidos nacionalmente e internacionalmente, manteniéndonos posicionados principalmente por la calidad y proyectos terminados satisfactoriamente, trayendo con ello calidad en nuestros productos y clientes más satisfechos con nuestros servicios.</p>
                      </div>
                    </Col>
                    <Col xs="0" sm="2"></Col>
                  </Row>
                </Container>
              </div>
              <div className="inf-Servicion">
                <Container>
                  <Row>
                    <Col xs="0" sm="2" ></Col>
                    <Col xs="12" sm="8">
                      <strong>PortaPrent </strong> 
                      Es una empresa orientada en brindar acompañamiento a sus clientes en sus proyecto teniendo como principal prioridad ayudar a tener éxito y rentabilidad en sus negocios, por eso brindamos atención personalizada en la implementación de productos publicitarios integrados con nuevas herramientas.
                      Contamos con capacidad intelectual e innovación para abordar cualquier tipos de proyectos en diferentes campos, estamos dispuestos a ofrecer el mejor de los servicios.
                    </Col>
                    <Col xs="0" sm="2" ></Col>
                  </Row>
                </Container>
              </div>
            </div>
        );
    }
}

export default QuienesSomos;



// WEBPACK FOOTER //
// ./src/Pages/QuienesSomos/QuienesSomos.jsx